import { useEffect, useRef } from "react";
import { api } from "../api/client";

const SID_KEY = "wwm_analytics_sid";
const UTM_KEY = "wwm_utm";

function getSessionId(): string {
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid) {
    // crypto.randomUUID() requires a secure context (HTTPS or localhost).
    // Fall back to a simple random hex string on plain HTTP origins.
    sid =
      typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : "xxxx-xxxx-xxxx".replace(/x/g, () =>
            Math.floor(Math.random() * 16).toString(16),
          );
    sessionStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

/** Parse UTM params from the URL on first visit; persist for the session. */
function getUtm(): { utm_source?: string; utm_medium?: string } {
  const stored = sessionStorage.getItem(UTM_KEY);
  if (stored) return JSON.parse(stored);

  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  const source = params.get("utm_source");
  const medium = params.get("utm_medium");
  if (source) utm.utm_source = source.slice(0, 64);
  if (medium) utm.utm_medium = medium.slice(0, 64);

  if (Object.keys(utm).length > 0) {
    sessionStorage.setItem(UTM_KEY, JSON.stringify(utm));
  }
  return utm;
}

/** Fire a page-view event on mount and on pathname changes. Fire-and-forget. */
export function usePageTracking(): void {
  const lastPath = useRef("");

  useEffect(() => {
    const path = window.location.pathname;

    // Skip admin pages and duplicate fires for the same path.
    if (path.startsWith("/admin") || path === lastPath.current) return;
    lastPath.current = path;

    api
      .track({
        path,
        session_id: getSessionId(),
        referrer: document.referrer || undefined,
        ...getUtm(),
      })
      .catch(() => {});
  });
}
